import React from 'react';
import { Spin } from 'syngenta-digital-cropwise-react-ui-kit';
import { useTranslation } from 'react-i18next';

const LoadingView = (props: any) => {
  const { dontUseFullScreen } = props;
  const { t } = useTranslation();
  return (
    <div
      data-cy="loading_view"
      data-testid="loading_view"
      className={`${
        !dontUseFullScreen ? 'h-screen' : ''
      } flex justify-center items-center flex-col`}
    >
      <div className="bold text-blue-50">{t('resource-mapper.loading')}</div>
      <Spin size="large" spinning className="syt-default" role="progress" />
    </div>
  );
};

export default LoadingView;
